export default {
  colors: {
    background: '#f0f2f5',
    red: '#e52e40',
    blue: '#5429cc',
    green: '#33CC95',

    blueLight: '#6933ff',
    borderColor: '#D7D7D7',

    textTitle: '#363f5f',
    textBody: '#969cb3',

    shape: '#fff',
  },
  fontSizes: {
    extraLarge: '3.2rem',
    large: '2.4rem',
    default: '1.6rem',
    small: '1.4rem',
  },
  radii: {
    default: '0.5rem',
  },
};
